import { render, staticRenderFns } from "./StoryStatisticTipItem.vue?vue&type=template&id=7272cff1&scoped=true&"
import script from "./StoryStatisticTipItem.vue?vue&type=script&lang=ts&"
export * from "./StoryStatisticTipItem.vue?vue&type=script&lang=ts&"
import style0 from "./StoryStatisticTipItem.vue?vue&type=style&index=0&id=7272cff1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7272cff1",
  null
  
)

export default component.exports